import { WorkInProgress } from "~/components/ui";

export function SurveyDetailSectionPage() {
  return <WorkInProgress />;
}
